<template>
  <div>
    <div class="flex gap-[7px] justify-end">
      <div
        class="flex items-center max-w-[250px] rounded-[8px] gap-[5px] px-[8px]  border-[1px] border-[#E2E2E2]"
      >
        <span
          class="k-search-normal-1 font-bold  align-middle"
          style="font-size: 20px"
        />
        <BFormInput
          v-model="search"
          placeholder="Cari nama, email"
          class="border-0"
          @input="searchData"
        />
      </div>
      <BDropdown
        id="dropdown-1"
        no-caret
        toggle-class="toggle-custom"
        variant="primary"
        right
        size="sm"
      >
        <template #button-content>
          <img
            src="https://storage.googleapis.com/komerce/assets/komerce-icon/Putih/filter-search.svg"
            alt="filter"
          >
        </template>
        <div
          class="text-[#333333] my-1 font-semibold text-[14px] px-[10px] min-w-[250px]"
        >
          Filter
        </div>
        <div class="x-[10px] my-1">
          <BDropdown
            id="dropdown-2"
            variant="none"
            toggle-class="toggle-form"
            class="w-full text-left mr-[100px]"
            no-caret
            dropleft
            right
          >
            <template #button-content>
              <div class="text-left -ml-[10px] font-[400] text-[#333333]">
                Status
              </div>
            </template>
            <BFormGroup class="m-0 p-[10px]">
              <BFormCheckboxGroup
                v-model="status"
                :options="statusOptions"
                stacked
                button-variant="primary"
              />
            </BFormGroup>
          </BDropdown>
        </div>
        <div
          class="cursor-pointer text-primary my-1 font-semibold text-[14px] px-[10px] min-w-[250px]"
          @click="onReset"
        >
          Reset Filter
        </div>
      </BDropdown>
    </div>
    <div class="lg:mt-1 lg:flex md:block sm:block sm:mt-3">
      <BCol
        v-for="(review, idx) in reviews"
        :key="idx"
        cols="12"
        lg="3"
        md="12"
        sm="12"
      >
        <BCard
          body-class="border border-[#E2E2E2] rounded-[8px]"
          class="text-black text-xl font-semibold"
        >
          <div class="flex gap-4">
            <img
              :src="review.image"
              alt="Komerce"
            >
            <span>
              {{ review.title }}
            </span>
          </div>
          <span>
            {{ review.count }}
          </span>
        </BCard>
      </BCol>
    </div>

    <BOverlay
      :show="loadingTable"
      spinner-variant="primary"
      variant="light"
      blur="0"
      opacity=".5"
      rounded="sm"
    >
      <div
        id="table"
        class="mt-1"
        style="height: calc(100vh - 250px); overflow-y: scroll;"
        @scroll="handleScroll"
      >
        <BTable
          :items="items"
          :fields="fields"
          show-empty
          empty-text="Tidak ada data"
          responsive
          hover
          selectable
          select-mode="single"
        >
          <template #cell(index)="data">
            <div class="flex items-center gap-4">
              <span>{{ data.index + 1 }}</span>
              <span
                :class="data.item.triggered_by === 'card' ? 'k-card' : data.item.triggered_by === 'admin' ? '' : 'k-user-square'"
                class="text-2xl"
              />
            </div>
          </template>
          <template #cell(name)="data">
            <div class="flex flex-col gap-4">
              <div class="flex gap-4">
                <span>{{ data.item.name }}</span>
                <img
                  v-if="!isEmpty(data.item.badge_user_level_url)"
                  :src="data.item.badge_user_level_url"
                  alt="Komerce"
                  width="20"
                >
              </div>
              <span>{{ data.item.email }}</span>
              <span>{{ data.item.phone }}</span>
            </div>
          </template>
          <template #cell(overdrawn_cards)="data">
            <span>{{ data.item.overdrawn_cards.minus }}/{{ data.item.overdrawn_cards.total }}</span>
            <br>
            <span class="text-primary">({{ IDR(data.item.overdrawn_cards.negative_balance) }})</span>
          </template>
          <template #cell(action)="data">
            <BDropdown
              :variant="data.item.status === 'on_review'
                ? 'outline-secondary'
                : (data.item.status === 'hold' || data.item.status === 'suspend')
                  ? 'outline-warning'
                  : 'outline-success'"
              offset="-100"
              left
              size="sm"
            >
              <template #button-content>
                <button>
                  {{ data.item.status === 'on_review'
                    ? 'On Review'
                    : (data.item.status === 'hold' || data.item.status === 'suspend')
                      ? 'Suspend'
                      :'Safe' }}
                </button>
              </template>
              <!-- Hold: aktif kecuali status sekarang sudah 'hold' -->
              <BDropdownItem
                :disabled="data.item.status === 'hold' || data.item.status === 'suspend'"
                @click="(data.item.status === 'hold' || data.item.status === 'suspend') ? null : onReview(data.item.user_id, 'Suspend User')"
              >
                <div class="flex gap-4">
                  <img
                    src="https://storage.googleapis.com/komerce/assets/icons/Ellipse-gray.svg"
                    alt="Hold"
                  >
                  <span :class="(data.item.status === 'hold' || data.item.status === 'suspend') ? 'text-[#C2C2C2]': 'text-primary'">Suspend</span>
                </div>
              </BDropdownItem>

              <!-- Safe: aktif kecuali status sekarang sudah 'safe' -->
              <BDropdownItem
                :disabled="data.item.status === 'safe'"
                @click="data.item.status === 'safe' ? null : onReview(data.item.user_id, ' Unsuspend User (Safe)')"
              >
                <div class="flex gap-4">
                  <img
                    src="https://storage.googleapis.com/komerce/assets/icons/Ellipse-gray.svg"
                    alt="Hold"
                  >
                  <span :class="data.item.status === 'safe' ? 'text-[#C2C2C2]': 'text-[#34A770]'">Safe</span>
                </div>
              </BDropdownItem>
            </BDropdown>
            <br>

            <div
              class="text-primary underline mt-1"
              @click="$router.push('/komcards-data-partner/' + data.item.user_id)"
            >
              Detail>>
            </div>
          </template>
        </BTable>
      </div>
    </BOverlay>

    <ModalReview
      :id="userId"
      :type="typeReview"
      @onRefetch="onModalRefetch"
    />
  </div>
</template>

<script>
import { IDR } from '@/libs/currency'
import { DAY_MONTH_YEAR } from '@/libs/filterDate'
import { newAxiosIns } from '@/libs/axios'
import isEmpty from 'lodash/isEmpty'
import { columnRiskReview } from './config'
import ModalReview from './ModalReview.vue'

export default {
  components: {
    ModalReview,
  },
  data() {
    return {
      isEmpty,
      items: [],
      loadingTable: false,
      fields: columnRiskReview,
      IDR,
      DAY_MONTH_YEAR,
      lastData: false,
      offset: 0,
      limit: 25,
      search: null,
      typeReview: null,
      userId: null,
      status: [],
      statusOptions: [
        { text: 'On Review', value: 'on_review' },
        { text: 'Hold', value: 'hold' },
        { text: 'Safe', value: 'safe' },
      ],
      reviews: [],
    }
  },
  watch: {
    status() {
      this.offset = 0
      this.getList()
    },
  },
  mounted() {
    this.getList()
    this.getReview()

    // to handle nested dropdown click anomaly
    // this.$root.$on('bv::dropdown::show', bvEvent => {
    //   if (bvEvent.componentId === 'dropdown-2') {
    //     this.isDropdown2Visible = true
    //     this.state_radio = this.has_card
    //   }
    // })
    // this.$root.$on('bv::dropdown::hide', bvEvent => {
    //   if (bvEvent.componentId === 'dropdown-2') {
    //     this.isDropdown2Visible = false
    //   }
    //   if (this.isDropdown2Visible) {
    //     bvEvent.preventDefault()
    //   }
    // })
  },
  methods: {
    onReview(id, type) {
      this.userId = id
      this.typeReview = type
      this.$bvModal.show('modal-review')
    },
    onModalRefetch() {
      // reset filters/params to initial state before refetching
      this.offset = 0
      this.status = []
      this.search = null
      this.limit = 25
      this.lastData = false
      this.items = []

      // re-fetch list and summary counts
      this.getList()
      this.getReview()
    },
    handleScroll() {
      const table = document.getElementById('table')
      if (
        table.scrollTop >= table.scrollHeight - table.offsetHeight - 5
        && !this.loading
        && !this.lastData
      ) {
        this.getNextData()
      }
    },
    onReset() {
      this.offset = 0
      this.status = []
      this.limit = 25
      this.search = null
    },
    searchData: _.debounce(function search(text) {
      this.offset = 0
      this.getList()
    }, 1000),
    async getList() {
      this.loadingTable = true

      const params = {
        search: this.search,
        action: this.status.join(','),
        offset: this.offset,
        limit: this.limit,
      }

      const url = '/komcards/api/v1/risk-review'
      await newAxiosIns
        .get(url, { params })
        .then(res => {
          const { data } = res.data
          this.loadingTable = false
          this.offset = data.length
          this.items = data
          if (data.length < this.limit) {
            this.lastData = true
          } else {
            this.lastData = false
          }
        })
        .catch(() => {
          this.$toast_error({ message: 'Gagal load data' })
          this.loadingTable = false
        })
    },
    async getReview() {
      const url = '/komcards/api/v1/risk-review/info'

      await newAxiosIns
        .get(url)
        .then(res => {
          const { data } = res.data
          const imageMap = {
            saved: 'https://storage.googleapis.com/komerce/assets/elements/Checkbox-on.svg',
            hold: 'https://storage.googleapis.com/komerce/assets/svg/warning-Info-circle.svg',
            on_review: 'https://storage.googleapis.com/komerce/assets/icons/icon-gray-circle.svg',
          }

          const titleMap = {
            saved: 'Safe ',
            hold: 'Hold',
            on_review: 'On Review',
          }

          this.reviews = Object.entries(data).map(([key, value]) => ({
            count: value,
            image: imageMap[key] || null,
            title: titleMap[key] || null,
          }))
        })
        .catch(() => {
          this.$toast_error({ message: 'Gagal load data' })
        })
    },
    getNextData() {
      if (!this.lastData) {
        this.loadingTable = true
        const params = {
          search: this.search,
          offset: this.offset,
          limit: this.limit,
          action: this.status.join(','),
        }

        const url = '/komcards/api/v1/risk-review'

        newAxiosIns
          .get(url, { params })
          .then(res => {
            const { data } = res.data
            this.items.push(...data)
            this.offset += data.length
            this.loadingTable = false
            if (data.length < this.limit) {
              this.lastData = true
            }
          })
          .catch(() => {
            this.loadingTable = false
            this.$toast_error({ message: 'Gagal load data' })
          })
      }
    },
  },
}
</script>
